import { Box, CircularProgress } from "@mui/material";
import React from "react";

/// loading indication to be used in dialogs
const Loading: React.FC = () => (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 3 }}>
        <CircularProgress size={60} thickness={4} />
    </Box>
);

export default Loading;
